import { render, staticRenderFns } from "./Distributeri.vue?vue&type=template&id=44687bd2&scoped=true&"
import script from "./Distributeri.vue?vue&type=script&lang=ts&"
export * from "./Distributeri.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44687bd2",
  null
  
)

export default component.exports